<template>
    <div class="product flex flex-wrap">
        <div class="img"><swiper /></div>
        <div class="container">
            <div class="title wow fadeInUp">
                <div class="en">our products</div>
                <div class="cn">我们的产品</div>
            </div>
            <div class="content wow fadeInUp">{{ $t('home.products') }}</div>
            <div class="icon wow fadeInUp"><img src="/images/icon5.png" alt=""></div>
            <div class="link flex flex-space-between flex-align-center wow fadeInUp" @click="goto">
                <div class="txt">
                    <div class="t1">more about</div>
                    <div class="t2">PRODUCTS</div>
                </div>
                <i class="fa fa-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from './Swiper.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Swiper
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langProducttype: state => state.langProducttype
    }),
    types () {
      return this.langProducttype[this.lang]
    }
  },
  methods: {
    goto(){
      this.$router.push({
        name: 'products',
        params: {
          tid: this.types[0].ID
        }
      })
    }
  }
}
</script>

<style scoped>
.product{
    background: url(/images/background3.png)no-repeat center / cover;
    padding: 100px 0;
}
.product .img{
    width: 50%;
    text-align: center;
}
.product .container{
    width: 50%;
    padding-left: 6.5%;
}
.product .container .title{
    border-bottom: 1px solid #aeaead;
    color: #004b94;
    padding: 30px 0;
}
.product .container .title .en{
    font-size: 50px;
    text-transform: uppercase;
    font-family: 'CANARO BOLD';
}
.product .container .title .cn{
    font-size: 35px;
}
.product .container .content{
    font-size: 14px;
    color: #696969;
    line-height: 35px;
    width: 630px;
    max-width: 100%;
    margin-top: 50px;
}
.product .container .icon{
    margin-top: 20px;
}
.product .container .icon img{
  max-width: 100%;
}
.product .container .link{
    font-family: 'CANARO BOLD';
    border: 1px solid #004b94;
    color: #004b94;
    padding: 5px 10px;
    text-transform: uppercase;
    width: 250px;
    max-width: 100%;
    margin-top: 50px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: .3s;
}
.product .container .link .txt .t1{
    font-size: 20px;
    line-height: 1em;
}
.product .container .link .txt .t2{
    font-size: 16px;
    line-height: 1em;
}
.product .container .link i{
    transition: .3s;
}
.product .container .link::before{
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: #004b94;
    transition: .3s;
    border-radius: 0 50px 50px 0;
    border-right: 50px solid #004b94;
    margin-left: -50px;
    z-index: -1;
}
.product .container .link:hover::before{
    left: 0;
    margin-left: 0;
}
.product .container .link:hover{
    color: #fff;
}
@media (max-width: 768px){
  .product{
    padding: 50px 0;
  }
  .product .img{
    width: 100%;
  }
  .product .container{
    width: 100%;
    padding: 0 20px;
  }
  .product .container .title .en{
    font-size: 24px;
  }
  .product .container .title .cn{
    font-size: 20px;
  }
}
</style>


